import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./CancelPage.module.css";
import { isMobileAppSurface } from "../../contexts/GlobalCallContext";

const CancelPage = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const price = sessionStorage.getItem("priceId");
  const updatetn = sessionStorage.getItem("updateBtn");
  // The page that initiated checkout sets this so we can return the
  // user there after they cancel. Falls back to the legacy flow below
  // for callers that don't set it yet.
  const cancelReturnTo = sessionStorage.getItem("cancelReturnTo");

  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const redirectTimeout = setTimeout(() => {
      if (cancelReturnTo) {
        sessionStorage.removeItem("cancelReturnTo");
        navigate(cancelReturnTo, { replace: true });
      } else if (updatetn) {
        navigate("/fast-agent-detail");
      } else if (token && price) {
        // "/plan" is the WEB plan screen. On the native app (Android/iOS) send
        // the user back to the mobile plan screen instead — /recommended-plan
        // re-shows the SAME offer they left from (via the go-live keep flag).
        navigate(isMobileAppSurface() ? "/recommended-plan" : "/plan", {
          replace: true,
        });
      } else {
        navigate(isMobileAppSurface() ? "/recommended-plan" : "/plans", {
          replace: true,
        });
      }
    }, 3000);

    sessionStorage.removeItem("checkPage");

    return () => {
      clearInterval(countdownInterval);
      clearTimeout(redirectTimeout);
    };
  }, [navigate, token, price, updatetn, cancelReturnTo]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.icon}>❌</div>
        <h1 className={styles.title}>Payment Cancelled</h1>
        <p className={styles.message}>
          Redirecting in {countdown} second{countdown !== 1 ? "s" : ""}...
        </p>
        <div className={styles.loader}></div>
      </div>
    </div>
  );
};

export default CancelPage;
